import { render, staticRenderFns } from "./addContactDia.vue?vue&type=template&id=725f688b&scoped=true"
import script from "./addContactDia.vue?vue&type=script&lang=js"
export * from "./addContactDia.vue?vue&type=script&lang=js"
import style0 from "./addContactDia.vue?vue&type=style&index=0&id=725f688b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725f688b",
  null
  
)

export default component.exports